import axios from "axios";
import { setAccessToken } from "../store/slices/auth/slice.js";

// export const BASE_URL = "http://localhost:5001";
export const BASE_URL = "https://api.receptizaroditeljstvo.rs";

const API_BASE_URL = `${BASE_URL}/api/`;
const ADMIN_AUTH_BASE_URL = `${BASE_URL}/api/auth/`;

let store;
export const injectStore = (_store) => {
  store = _store;
};

const axiosApiClient = axios.create({
  baseURL: API_BASE_URL,
});

const axiosAdminAuthClient = axios.create({
  baseURL: ADMIN_AUTH_BASE_URL,
});

const axiosAdminApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Add auth interceptor for regular API client too
axiosApiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().authInfo.token;
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosAdminAuthClient.interceptors.request.use(
  (config) => {
    config.headers = {};
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosAdminApiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().authInfo.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosAdminApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    // Check if error.response exists and has status 401
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await axiosAdminAuthClient.post(
          "/refresh-token",
          {},
          {
            withCredentials: true,
          },
        );
        const { accessToken } = refreshResponse.data.data;
        store.dispatch(setAccessToken({ accessToken }));
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        // Token refresh failed - logout user
        store.dispatch({ type: "logout" });
        // Clear localStorage
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosAdminApiClient;
export { axiosApiClient, axiosAdminApiClient, axiosAdminAuthClient };
